<script setup>
import { useMainStore } from '../stores/main-store'

const mainStore = useMainStore()

const props = defineProps({
  name: {
    type: String,
    default: '',
  },
  attribute: {
    type: Object,
    default: () => {},
  },
})

const handleClick = () => {
  const { taxonomy, slug } = props.attribute
  mainStore[props.name][taxonomy][slug] = false
}
</script>

<template>
  <button class="filter-button" type="button" @click="handleClick">
    {{ attribute.title }}
  </button>
</template>

<style lang="scss">
@import '../scss/current-filter-button';
</style>
